<template>
    <div class="newsDetail">
        <!-- 头部导航公共组件 -->
        <Header :videoHeight="videoHeight" :iseNavigat="isChildeNavigat" :isScroll="isScroll" :isMobile="isMobile"></Header>

        <!-- 主体内容 -->

        
       
        <section class="video_wrap" ref="videoHeight">
            <div v-if="videoType == '视频'">
                <video class="primary-video" muted autoplay loop ref="videoPlayer" :src="videoUrl"></video>
            </div>
            <img style="width: 100%;height: 100%;object-fit: cover;" :src="videoUrl" @contextmenu.prevent v-else/>

            <div class="watermark-effect" v-if="detailObj.isntitle == 1">
                <h4>{{ detailObj.engtitle.split(';').join('\n') }}</h4>
                <h2>{{ detailObj.ntitle.split(';').join('\n') }}</h2>
                
            </div>
            <!-- -->
        </section>


        <section class="section-details" ref="detailRefs">
            <div class="article-model" ref="articleModel">
                <h4 class="article-dec">
                    {{ detailObj.engtitle.split(';').join('\n') }}
                </h4>
                <h2 class="article-title">
                    {{ detailObj.ntitle.split(';').join('\n') }}
                </h2>
                

                <div class="grid-content bg-purple" style="margin-bottom: 60px;">
                    <div style="white-space: pre-wrap;">{{ detailObj.ncontent }}</div>

                    <div style="font-family: 'ahronbd';font-size: 20px;margin-top: 40px;line-height: 23px;font-weight: 700;white-space: pre-wrap;">{{ detailObj.econtent }}</div>
                </div>

                <!-- <div class="grid-content">
                    <div style="margin-bottom: 20px;">
                        <h4 class="article-dec" style="font-size: 23px;">Project Information</h4>
                        <h2 class="article-title" style="font-size: 24px;">项目信息</h2>
                    </div>
                    <div v-for="(item, index) in ceInfos" :key="index">
                        <div style="margin-bottom: 5px;height: auto;overflow: hidden;line-height: 25px;">
                            <strong style="display: block;width: 100px;font-size: 19px;letter-spacing:0.095em;float: left;" v-if="item.tname == '发 展 商'" >{{ item.tname }}：</strong>
                            <strong style="display: block;width: 100px;font-size: 19px;float: left;" v-else>{{ item.tname }}：</strong>
                            <span v-if="item.tname == '设计时间' || item.tname == '竣工时间'" style="display: block;font-size: 19px;float: left;">{{ item.tvalue }}</span>
                            <span v-else style="display: inline-block;font-size: 19px;">
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[0] }}</span>
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[1] }}</span>
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[2] }}</span>
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[3] }}</span>
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[4] }}</span>
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[5] }}</span>
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[6] }}</span>
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[7] }}</span>
                                <span style="display: block;font-size: 19px;">{{ item.tvalue.split(';')[8] }}</span>
                            </span>
                        </div>
                    </div>

                    <div style="margin-top: 20px;" v-if="enInfos.length > 0">
                        <div style="margin-bottom: 5px;font-family: 'ahronbd';font-weight: 700;align-items: center;width: 100%;height: auto;overflow: hidden;line-height: 25px;" v-for="(item, index) in enInfos" :key="index">
                            <strong style="display: block;font-size: 20px;float: left;">{{ item.tname }}：</strong>
                            <span style="font-size: 20px;align-items: center;display: block;float: left;">
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[0] }}</span>
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[1] }}</span>
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[2] }}</span>
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[3] }}</span>
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[4] }}</span>
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[5] }}</span>
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[6] }}</span>
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[7] }}</span>
                                <span style="display: block;font-size: 20px;">{{ item.tvalue.split(';')[8] }}</span>
                            </span>
                        </div>
                    </div>
                </div> -->

                <div style="margin-top: 30px;"><img src="../assets/images/shuiying.png" /></div>

            </div>
            <!-- <div v-if="proidValue != 0"> -->
            <div>
                <el-row :gutter="10">
                    <el-col :lg="{span:'4-8'}" :md="6" :sm="12" :xs="24" v-for="(item, index) in detailObj.imgs" :key="index" >
                        <div style="padding-bottom: 5px;cursor: pointer;" :key="index" @click="handleImagePreview(index)">
                            <img :src="item.fileurl" style=" width: 100%;height: 100%;object-fit: contain;" @contextmenu.prevent>
                        </div>
                    </el-col>
                </el-row>
            </div>
                
            
            
            <!-- </div> -->
            
            <!-- <div style="margin-bottom: 15px;" v-if="proidValue == 0">
                <img src="../assets//images/product_img_1.png" style="width: 100%;">
            </div>
            <div id="videoFullPlayer" controls style="margin: 90px 0 0px 0;" v-if="proidValue == 0">
                <video style="width: 100%;" src="../assets/images/veido1.mp4" controls ref="videoFullPlayer" @click="toggleFullscreen"></video>
            </div> -->
            <div id="videoFullPlayer" style="margin: 90px 0 100px 0;">

                 <div style="margin-bottom: 15px;" v-for="(item, index) in botsVideoList" :key="index" :ref="'videoModeHeight'+index">
                    <video style="width: 100%;" :src="item.fileurl" controls controlsList="nodownload  noplaybackrate" disablePictureInPicture="true" :ref="'videoFullPlayer'+index" @webkitfullscreenchange="handleVideoFullScreenChange" @mozfullscreenchange="handleVideoFullScreenChange" @fullscreenchange="handleVideoFullScreenChange"  @play="handlePlay(index)" @click="playAndFullScreen(index)"></video>
                 </div>
                 <!-- <div ref="videoPlayers" class="vimeo-player" :video-id="item.nsort" style="width: 100%;height: 500px;" v-for="(item, index) in botsVideoList" :key="index"></div> -->
                  <!-- @play="handlePlay(index)" @pause="handlePause(index)" -->
                  <!-- <video-player class="video-player-box" :options="playerOptions"></video-player> -->
                
            </div>
        </section>

        <!-- <video-player :options="playerOptions" class="vjs-custom-skin"></video-player> -->
        <!-- handleVideoFullScreenChange -->
         <!-- @webkitfullscreenchange="handleVideoFullScreenChange" @mozfullscreenchange="handleVideoFullScreenChange" @fullscreenchange="handleVideoFullScreenChange" -->
         <!--  -->

        <!-- <div style="position: relative;">
            <el-carousel :interval="5000" arrow="always" :autoplay="false" class="detail-image-box">
                <el-carousel-item v-for="(item, index) in detailObj.imgs"  :key="index">
                    <section class="detail-image-box">
                        <img :src="item.fileurl" />
                    </section>
                </el-carousel-item>
            </el-carousel>
            <div style="position: absolute;bottom: 5px;font-size: 24px;color: rgba(255, 255, 255, 0.5);z-index: 99;left: 50%;font-family: 'SourceHanSans';">1 / {{ detailObj.imgs.length }}</div>
        </div> -->
        

        <!-- <section class="section-details" style="padding-bottom: 100px;" ref="videoHightbox">
            <div id="videoFullPlayer" style="margin: 90px 0 0px 0;" v-if="botsVideoUrl != ''">
                <video style="width: 100%;" :src="botsVideoUrl" controls ref="videoFullPlayer" @click="toggleFullscreen"></video>
            </div>
        </section> -->

        <!-- 图片预览弹窗 -->
        <div class="Image-Preview-box" v-if="ImagePreviewModle">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" @click="handelImagePreviewClose">
                <img src="../assets/images/close-white.png" />
            </div>
            <el-carousel :interval="0" arrow="always" :autoplay="false" :loop="false" class="Image-Preview-box" ref="ImageCarousel" :initial-index="activeIndexInitial" v-model="activeIndex" @change="handleArrowClick" @touchstart.native="handleTouchStart" @touchmove.native="handleTouchMove" @touchend.native="handleTouchEnd" v-if="isPC">
                <!-- <button class="carousel-control prev"><img src="../assets/images/button-right.png" alt="Previous"></button> -->
                <el-carousel-item v-for="(item, index) in ImagePreviewList" :key="index">
                    <section class="Image-Preview-box" @click="handelImagesExitFullscreen">
                        <img :src="item.fileurl" @contextmenu.prevent/>
                    </section>
                </el-carousel-item>
            </el-carousel>

            <swiper class="Image-Preview-box" :options="swiperOptions" v-if="isMobile">
                <swiper-slide v-for="(item, index) in ImagePreviewList" :key="index">
                    <section @click="handelImagesExitFullscreen" style="height: 100%;">
                        <img :src="item.fileurl" @contextmenu.prevent/>
                    </section>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>

        <!-- 提示 -->

        





        <!-- 推荐项目 -->
        <div class="recommended-project" ref="recomBox" v-if="recomlist.length > 0">
            <div class="recommended-project-content">
                <el-row :gutter="36">
                    <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" v-for="(item, index) in recomlist" :key="index">
                        <div class="project-section" @click="handelDetail(item.proid,item.utype)">
                            <div class="project-img">
                            <img class="main-image" :src="item.fileurl" @contextmenu.prevent>
                            <img class="secondary-image" :src="item.fileurl" @contextmenu.prevent>
                            </div>
                            <div class="project-model-box">
                            <div class="project-name-box">
                                <p>{{ item.introstr }}</p>
                                <h5 :title="item.proname">{{ item.proname }}</h5>
                            </div>
                            <div class="project-time-box">
                                <div style="margin-bottom: 5px;">{{ item.projectctime }}</div>
                                <div style="display: flex;align-items: center;">
                                    <span style="display: flex;align-items: center;font-weight: 500;width: 100%;justify-content: flex-start;"><img style="width: 19px;margin-right: 5px;" src="../assets/images/yan_1.png"/> <span>{{ item.bornum }}</span></span>
                                
                                </div>
                            </div>
                        </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- 返回上一页 -->
        <div class="backIcon" @click="handleGoBack"><img src="../assets/images/button-left-hover.png" /></div>

        <!-- 尾部导航公共组件 -->
        <Footer ref="footeHeig"></Footer>
        <!-- end -->
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import _ from 'lodash';
// import { VideoPlayer } from '@videojs/vue-video'
// import 'video.js/dist/video-js.css'
// import { videoPlayer } from 'vue-video-player'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { getProjectDetail,setPageViewInfo } from '@/api/axios-api'

export default {
    name: 'ProjectDetail',
    components: {
        Header,
        Footer,
        Swiper,
        SwiperSlide,
        // VideoPlayer
        // Footer,
        // HelloWorld,
        // loading
    },
    data () {
        return {
            playerOptions: {
                autoplay: false,
                controls: true,
                sources: [{
                type: "video/mp4",
                src: "http://172.16.62.226/download/pro/video/1761120180959.mp4"
                }]
            },
            ImagePreviewList: [],
            isChildeNavigat: false,
            ImagePreviewModle: false,
            isScroll: 0,
            videoHeight: 0,
            detailObj: {},
            videoUrl: '',
            videoType: '',
            proidValue: '',
            infos: [],
            ceInfos: [],
            enInfos: [],
            botsVideoList: [],
            botsVideoListulr: '',
            // lastScrollTime: 0, // 上次滚动的毫秒时间戳
            // scrollSpeed: 500, // 滚动速度（毫秒）
            articleModelHeight: 0,
            lastScrollTime: 0, // 上次滚动的毫秒时间戳
            scrollSpeed: 0, // 滚动的速度
            activeIndex: 0,
            activeIndexInitial: 0,
            isuatoSroll: true,
            isuatodowSroll: true,
            isPic: 1, // 0 不显示， 1显示
            savedTime: 0, // 保存视频播放位置
            isRollerSpeed: true,
            isFullScreen: false, // 控制是否全屏的标志
            scrollPosition: 0, // 用于存储滚动位置
            isScrollPosition: true,
            currentVideoIndex: null,
            currentPlaying: null, // 存储当前播放的视频索引
            recomlist: [],
            isPC: false, // 代表pc端
            isMobile: false, // 代表移动端
            swiperOptions: {
                initialSlide: 0, // 设定初始化时slide的索引
                // direction: 'vertical', // Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
            startX: 0,
            currentX: 0,
            touchThreshold: 50, // 设置触发滑动的阈值（像素）
        }
    },
    created () {
         window.scrollTo(0, 0)
         const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|Macintosh|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
         if (userAgent) {
            this.isMobile = true
         } else {
            this.isPC = true
            
         }
    },
    mounted () {
        // alert('1212')
        // window.scrollTo(0, 0)
       
        this.proidValue = this.$route.query.proid
        
        this.getProjectDetailFun(this.$route.query.proid,this.$route.query.pwdstr)

        this.$nextTick(() => {
            // console.log(this.$refs.videoHeight)
            this.videoHeight = this.$refs.videoHeight.offsetHeight
            
        })
       
        document.body.style.overflow = 'auto'

        // window.addEventListener('scroll', this.scrollBodyTop)

        // window.addEventListener('beforeunload', this.scrollUploadToTop)
        // window.addEventListener('scroll', this.scrollUploadToTop)

        window.addEventListener('keydown', this.globalKeyDown)
        // const screenHeight = window.innerHeight

        window.addEventListener('scroll', this.saveScrollPosition)
        
        // window.addEventListener('scroll', this.CloseVideo)
        
        
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scrollUploadToTop)
        window.removeEventListener('keydown', this.globalKeyDown)

    },
    watch: {
        '$route'() {
            // console.log(this.$route.query)
            this.getProjectDetailFun(this.$route.query.proid,this.$route.query.pwdstr)
            window.scrollTo(0, 0)
            //  alert('1212')
            // document.documentElement.scrollTop = 0
        },
    },
    methods: {
        handleGoBack () {
            this.$router.go(-1)
        },
        // handelSD () {
        //     alert('1212')
        //     window.scrollTo(0, 3600); // 恢复滚动位置
        // },
         handlePlay(index) {
            if (this.currentPlaying !== null && this.currentPlaying !== index) {
                this.pauseVideo(this.currentPlaying)
            }
            this.currentPlaying = index
        },
        pauseVideo(index) {
            const videoElement = this.$refs[`videoFullPlayer${index}`][0] // 获取对应的video DOM元素
            if (videoElement) {
                videoElement.pause() // 暂停视频播放
            }
        },

        // CloseVideo () {
            
        //     // console.log(window.scrollY)
        //     if (window.scrollY > 3600) {
        //         if (this.botsVideoList.length > 0) {
        //             for (let i = 0; i < this.botsVideoList.length; i++) {
        //                 const videoElement = this.$refs[`videoFullPlayer${i}`][0]
        //                 videoElement.pause()
        //             }
        //         }
                
        //         // console.log(this.$refs.videoFullPlayer0).$el
        //     }
        // },

        playAndFullScreen (index) {
            // console.log(index)
            // const videoElement = this.$refs['videoFullPlayer'+index]
            // console.log(videoElement)
            // if (videoElement) {
            //     videoElement.play(); // 开始播放视频
            // } 
            const videoElement = this.$refs[`videoFullPlayer${index}`][0]
            // console.log(videoElement)
            if (videoElement.pause) {
                videoElement.play() // 播放指定索引的视频
            }
            else {
                videoElement.pause() // 暂停视频（如果需要）
            }

            // this.toggleVidoFullScreen()
        //     const videoElement = this.$refs.videoFullPlayer
        //     // console.log(videoElement)
        //     // const videoElement = this.$el.querySelector(`video`).cloneNode(true); // 克隆视频元素以保持状态
        //    videoElement.play().catch(err => {
        //         console.error("Error attempting to play!", err);
        //     });
            if (!document.fullscreenElement) {
                this.saveScrollPosition()
                videoElement.play() // 播放指定索引的视频
                videoElement.requestFullscreen().catch(err => {
                    console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });

            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen().then(() => {
                        // 退出全屏后，滚动到顶部或其他位置
                        // window.scrollTo(0, 3600); // 例如，滚动到页面顶部
                        this.restoreScrollPosition()
                    }).catch(err => {
                        console.log('Error attempting to exit full-screen mode:', err);
                    });
                }
                // if (document.exitFullscreen) {
                // // window.scrollTo(0, 3600)
                //     document.exitFullscreen()
                //     this.restoreScrollPosition()
                // }
            }
            
        },

       


        handleVideoFullScreenChange () {

            if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen) {
                // 全屏退出，暂停播放
                this.restoreScrollPosition()
            
            } else {
                // console.log('11111')
                // this.saveScrollPosition()
                // console.log(this.isScrollPosition)
            }
        },

        saveScrollPosition() {
            if (window.scrollY > 0) {
                this.scrollPosition = window.scrollY
                // sessionStorage.setItem('scrollPosition',window.scrollY) // 保存滚动位置
                // console.log(this.scrollPosition)
            }
            
            // console.log(this.scrollPosition)
            // if (window.scrollY > 0) {
            //     sessionStorage.setItem('scrollPosition',window.scrollY) // 保存滚动位置
            // }    

        },
        restoreScrollPosition() {
            // console.log('---------'+this.scrollPosition)
            // alert('12121')
            // this.$nextTick(() => {
                // window.scrollTo(0,1000)
            // })
            // this.scrollPosition = window.scrollY
            // this.
            // window.scrollTo(0, sessionStorage.getItem('scrollPosition')); 
            window.scrollTo(0, this.scrollPosition); // 恢复滚动位置
            // alert(this.scrollPosition)
        },
        globalKeyDown(event) {
            if (event.key === 'ArrowLeft') {
                // console.log('左键被按下');
                // 处理左键逻辑
                this.prevImageSlide();
            } else if (event.key === 'ArrowRight') {
                // console.log('右键被按下');
                // 处理右键逻辑
                this.nextImageSlide();
                
            } else if (event.key === 'Escape') {
                // 按下esc
                // console.log('121')
                // $Modal.remove()
                this.activeIndex = 0
                this.ImagePreviewList = []
                this.ImagePreviewModle = false
                document.body.style.overflow = 'auto'

                this.restoreScrollPosition()

                // this.$refs.videoFullPlayer.pause();
                // this.restoreScrollPosition()
            } 
        },

        toggleFullScreen() {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
                })
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                }
            }
        },

        handleImagePreview (index) {

            this.swiperOptions.initialSlide = index

            this.ImagePreviewList = this.detailObj.imgs
            this.activeIndex = index
            this.activeIndexInitial = index
            this.ImagePreviewModle = true
            document.body.style.overflow = 'hidden'
            this.toggleFullScreen()
            
            this.ImageMouseWheelListener()
            
        },

        handelImagesExitFullscreen () {

           if ((this.activeIndex + 1) == this.detailObj.imgs.length) {
                this.activeIndex = 0
                this.ImagePreviewList = []
                document.exitFullscreen()
                this.ImagePreviewModle = false
                window.removeEventListener('wheel', this.ImageMouseWheelListener)
                document.body.style.overflow = 'auto'
           }
           
        },

        handleArrowClick (value) {
            this.activeIndex = value
        },

        handelImagePreviewClose () {
           
            this.activeIndex = 0
            this.ImagePreviewList = []
            this.ImagePreviewModle = false
            document.body.style.overflow = 'auto'
            document.exitFullscreen()
            window.removeEventListener('wheel', this.ImageMouseWheelListener)
            
            
        },
        ImageMouseWheelListener: _.throttle(function() {

            this.$nextTick(() => {
                const carouselImageEl = this.$refs.ImageCarousel.$el; // 获取 Carousel 元素的引用

                carouselImageEl.addEventListener('wheel', (event) => {
                    // console.log(event)

                    if (this.isRollerSpeed) {
                        if (event.deltaY < 0) {
                        // 向前滚动（向上）
                            this.prevImageSlide();
                        } else {
                        // 向后滚动（向下）
                            this.nextImageSlide();
                        
                        }
                    }
                    this.isRollerSpeed = false
                    setTimeout(() => {
                        this.isRollerSpeed = true
                        event.preventDefault()
                    }, 1500)
                    
                })
            })
            
        },1500),
            
        

        nextImageSlide() {
            // console.log(this.detailObj.imgs.length)
            if ((this.activeIndex + 1) < this.detailObj.imgs.length) {

                this.activeIndex = (this.activeIndex + 1) % this.detailObj.imgs.length
                this.$refs.ImageCarousel.next(); // 调用 Carousel 的 next 方法
                // console.log('加'+this.activeIndex)
            }
            
            
        },
        prevImageSlide() {

            if (this.activeIndex > 0) {
                this.activeIndex = (this.activeIndex - 1) % this.detailObj.imgs.length
                this.$refs.ImageCarousel.prev(); // 调用 Carousel 的 prev 方法
                // console.log('减'+this.activeIndex)
            }
            
        },

        // pc端电脑触屏滑动轮播
        handleTouchStart(event) {
            this.startX = event.touches[0].clientX;
        },
        handleTouchMove(event) {
            this.currentX = event.touches[0].clientX;
        },

        handleTouchEnd() {
            if (Math.abs(this.currentX - this.startX) > this.touchThreshold) {
                if (this.currentX - this.startX > 0) {
                   this.activeIndex = (this.activeIndex + 1) % this.detailObj.imgs.length
                // 向左滑动，切换到下一张图片（此处需要调用 Element UI 的方法或通过索引控制）
                 this.$refs.ImageCarousel.prev(); // 同上，需要有 ref="carousel" 在 el-carousel 上
                } else {
                 this.activeIndex = (this.activeIndex - 1) % this.detailObj.imgs.length   
                // 向右滑动，切换到上一张图片（此处需要调用 Element UI 的方法或通过索引控制）
                
                this.$refs.ImageCarousel.next(); // 假设你有一个 ref 在 el-carousel 上，例如 ref="carousel"
                }
            }
        },
        

        // scrollUploadToTop () {
        //     window.scrollTo(0, 0)
        // },

        getProjectDetailFun (proid,pwdstr) {
            const parseInfo = {}
            parseInfo.proid = proid
            parseInfo.pwdstr = pwdstr
            getProjectDetail(parseInfo).then(res => {
                // console.log(res)
                if (res.code == 0) {
                    this.detailObj = res.map.map
                    this.videoUrl = res.map.map.videos[0].fileurl
                    this.videoType = res.map.map.videos[0].typename
                    this.recomlist = res.map.map.recomlist

                    for (let i = 0; i < res.map.map.infos.length; i++) {
                        const infoObj = {}
                        if (res.map.map.infos[i].etype == 1 && res.map.map.infos[i].tvalue != '') {
                            infoObj.tname = res.map.map.infos[i].tname
                            infoObj.tvalue = res.map.map.infos[i].tvalue
                            this.ceInfos.push(infoObj)
                        } else if (res.map.map.infos[i].etype == 2 && res.map.map.infos[i].tvalue != '') {
                            infoObj.tname = res.map.map.infos[i].tname
                            infoObj.tvalue = res.map.map.infos[i].tvalue
                            this.enInfos.push(infoObj)
                        }
                    }
                    this.infos = res.map.map.infos
                    if (res.map.map.bots.length > 0) {
                        this.botsVideoList = res.map.map.bots

                        this.botsVideoListulr = res.map.map.bots[0].fileurl
                    }
                }
            })
        },

        handelDetail (proid,utype) {
            // proid
           const parseInfo = {}
            parseInfo.proid = proid
            setPageViewInfo(parseInfo).then(res => {
                console.log(res)
            })
            if (utype == 1) {
                this.$router.push({
                path: '/projectDetail',
                query: {proid: proid}
                })
            } else if (utype == 2) {
                this.$router.push({
                path: '/newsDetail',
                query: {proid: proid}
                })
            }
        },    

    }
}
</script>

<style scoped lang="scss">
.newsDetail {
  width: 100%;
  height: 100vh
}
.newsDetail .video_wrap {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 8;
}
.newsDetail .primary-video {
  width: 100%;
  object-fit: cover;
  height: 100vh;
}
.newsDetail .watermark-effect {
    width: 100%;
    position: absolute;
    z-index: 99;
    bottom: 13vh;
    text-align: center;
    color: #fff;
    opacity: 0;
    animation: fadeInEffect 2s ease-out forwards; /* 应用动画 */
}
.newsDetail .Image-Preview-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    z-index: 99;
}
.newsDetail .backIcon {
    width: 20px;
    height: 36px;
    position: fixed;
    left: 30px;
    // bottom: 200px;
    cursor: pointer;
    top: 50%;
    margin-top: -18px;
}
.newsDetail .backIcon img {
    width: 100%;
    height: 100%;
}

@keyframes fadeInEffect {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
}

.newsDetail .watermark-effect h2 {
    font-size: 40px;
    white-space: pre-line;
    font-family: "SourceHanSansBOLD";
}
.newsDetail .watermark-effect h4 {
    font-size: 35px;
    font-weight: 700;
    line-height: 22px;
    font-family: "ahronbd";
}
.newsDetail .section-details {
    width: calc(100% - 120px);
    margin: auto;
    height: auto;
}
.newsDetail .article-model {
    padding: 40px 150px;
    font-size: 24px;
    font-weight: 500;
    font-family: "SourceHanSans";
    color: #000;
}
.newsDetail .article-model .article-title {
    font-size: 30px;
    // font-weight: 700;
    white-space: pre-line;
    margin-bottom: 15px;
    color: #000;
    // color: #2f4455;
    font-family: "SourceHanSansBOLD";
    // 
}
.newsDetail .article-model .article-dec {
    font-size: 29px;
    font-weight: 700;
    font-family: "ahronbd";
    color: #000;
}

.newsDetail .recommended-project {
    display: inline-block;
    width: 100%;
    background: #2F4455;
    padding: 143px 0 17px 0;
}
.newsDetail .recommended-project-content {
    
    width: calc(100% - 60px);
    margin: auto;
}
.newsDetail .project-section {
  margin-bottom: 15px;
  // text-align: center;
  font-family: "SourceHanSans";
  cursor: pointer;
  color: #fff;
}
.newsDetail .project-img {
  width: 100%;
  height: 210px;
  position: relative;
  overflow: hidden;
}

.newsDetail .project-img .main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  // transition: opacity 0.5s ease; /* 平滑过渡效果 */
}
.newsDetail .project-img .secondary-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  opacity: 0; /* 默认隐藏 */
  // transition: opacity 0.5s ease; /* 平滑过渡效果 */
}
.newsDetail .project-img:hover .main-image {
  opacity: 0;
}
.newsDetail .project-img:hover .secondary-image {
  opacity: 1;
}
.newsDetail .project-section h5 {
  font-size: 18px;
  font-weight: 700;
  font-family: "SourceHanSans";
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器的部分 */
  text-overflow: ellipsis; /* 显示省略号 */
  padding-bottom: 7px;
}
.newsDetail .project-section p {
  // height: 36px;
  // line-height: 20px;
  font-size: 20px;
  padding: 12px 0 0px 0;
  font-family: "ahronbd";
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.newsDetail .project-model-box {
  display: flex;
  justify-content: space-between;
  height: 70px;
  color: #fff;
}
.newsDetail .project-name-box {
  width: 65%;
}
.newsDetail .project-time-box {
  font-size: 14px;
  font-family: Arial;
  padding: 12px 0 0 0;
}
.newsDetail .detail-image-box {
    width: 100%;
    height: 100vh;
}
.newsDetail .detail-image-box::v-deep .el-carousel__container {
    height: 100vh;
}
.newsDetail .detail-image-box::v-deep .el-carousel__indicators {
    display: none;
}
.newsDetail .detail-image-box::v-deep .el-carousel__arrow {
    background-color: rgba(31, 45, 61, .8);
}
.newsDetail .detail-image-box img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.newsDetail .Image-Preview-box {
    width: 100%;
    height: 100vh;
}
.newsDetail .Image-Preview-box img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.newsDetail .Image-Preview-box::v-deep .el-carousel__container {
    height: 100vh;
}

.newsDetail .Image-Preview-box::v-deep .el-carousel__item.is-animating {
  transition: transform 1s ease-in-out;
}
.newsDetail .Image-Preview-box::v-deep .el-carousel__arrow {
    // background-image: url('../assets/images/button-right.png');
    background-color: rgba(255,255,255,0);
}
// .projectDetail .Image-Preview-box::v-deep .el-carousel__arrow .el-icon-arrow-right {
//     background-image: url('../assets/images/button-right.png');
//     background-size: 100% 100%;
// }


.newsDetail .Image-Preview-box::v-deep .Image-Preview-box .swiper-button-next {
    background-image: url('../assets/images/button-right.png');
    background-size: 100% 100%;
    width: 20px;
    height: 36px;
}
.newsDetail .Image-Preview-box::v-deep .Image-Preview-box .swiper-button-next::after {
    display: none;
}

.newsDetail .Image-Preview-box::v-deep .Image-Preview-box .swiper-button-prev {
    background-image: url('../assets/images/button-left.png');
    background-size: 100% 100%;
    width: 20px;
    height: 36px;
}

.newsDetail .Image-Preview-box::v-deep .Image-Preview-box .swiper-button-prev::after {
    display: none;
}

.newsDetail .Image-Preview-box::v-deep .el-carousel__arrow--right i {
    
    background-image: url('../assets/images/button-right.png');
    background-size: 100% 100%;
    width: 20px;
    height: 36px;
}
.newsDetail .Image-Preview-box::v-deep .el-carousel__arrow--right i:active {
    background-image: url('../assets/images/button-right-hover.png');
}
.newsDetail .Image-Preview-box::v-deep .el-icon-arrow-right:before {
    opacity: 0;
}

.newsDetail .Image-Preview-box::v-deep .el-carousel__arrow--left i {
    
    background-image: url('../assets/images/button-left.png');
    background-size: 100% 100%;
    width: 20px;
    height: 36px;
}
.newsDetail .Image-Preview-box::v-deep .el-carousel__arrow--left i:active{
    background-image: url('../assets/images/button-left-hover.png');
}
.newsDetail .Image-Preview-box::v-deep .el-icon-arrow-left:before {
    opacity: 0;
}

.newsDetail .Image-Preview-box::v-deep .el-carousel__indicators {
    display: none;
}
// .projectDetail .Image-Preview-box::v-deep .el-carousel__arrow [class^=el-icon-] {
//     font-family: "ahronbd"!important;
// }

@media (max-width: 1920px) {
    .newsDetail .article-model {
        padding: 40px 150px;
    }
}
@media (max-width: 1200px) {
    .newsDetail .article-model {
        padding: 40px 60px;
    }
}
@media (max-width: 992px) {
    .newsDetail .article-model {
        padding: 40px 60px;
    }
    
}
@media (max-width: 768px) {
    .newsDetail .article-model {
        padding: 40px 0px;
    }
}

@media only screen and (min-width: 768px) {
    .el-col-sm-4-8 {
      width: 20%;
    }
    .el-col-sm-offset-4-8 {
      margin-left: 20%;
    }
    .el-col-sm-pull-4-8 {
      position: relative;
      right: 20%;
    }
    .el-col-sm-push-4-8 {
      position: relative;
      left: 20%;
    }
  }

@media only screen and (min-width: 992px) {
.el-col-md-4-8 {
    width: 20%;
}
.el-col-md-offset-4-8 {
    margin-left: 20%;
}
.el-col-md-pull-4-8 {
    position: relative;
    right: 20%;
}
.el-col-md-push-4-8 {
    position: relative;
    left: 20%;
}
}

@media only screen and (min-width: 1200px) {
.el-col-lg-4-8 {
    width: 25%;
}
.el-col-lg-offset-4-8 {
    margin-left: 25%;
}
.el-col-lg-pull-4-8 {
    position: relative;
    right: 25%;
}
.el-col-lg-push-4-8 {
    position: relative;
    left: 25%;
}
}
@media only screen and (min-width: 1500px) {
.el-col-lg-4-8 {
    width: 20%;
}
.el-col-lg-offset-4-8 {
    margin-left: 20%;
}
.el-col-lg-pull-4-8 {
    position: relative;
    right: 20%;
}
.el-col-lg-push-4-8 {
    position: relative;
    left: 20%;
}
}

@media only screen and (min-width: 1920px) {
.el-col-xl-4-8 {
    width: 20%;
}
.el-col-xl-offset-4-8 {
    margin-left: 20%;
}
.el-col-xl-pull-4-8 {
    position: relative;
    right: 20%;
}
.el-col-xl-push-4-8 {
    position: relative;
    left: 20%;
}
}
// @media (max-width: 768px) {
//     .projectDetail .article-model {
//         padding: 40px 60px;
//     }
// }
</style>

